<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="mt-2 col-md-12"></div>


    <div class="mb-4 text-left">
      Fecha de llenado de la historia clínica física:
      <strong>
        {{
          infoPaciente.historia.fechaModificacion | formatoFechaHoraTexto
        }}</strong
      >
    </div>

    <b-form v-on:submit.prevent="enviarFormulario">
      <h3 class="subtitulos">Datos del Paciente</h3>

      <div>
        <b-row>
          <b-col>
            <label for="Apellido paterno"> Apellido Paterno: </label>
            <b-form-input
              v-model="infoPaciente.persona.apellidoPaterno"
              placeholder="Apellido paterno:"
              disabled
            >
            </b-form-input>
          </b-col>
          <b-col>
            <label for="Apellido materno"> Apellido materno: </label>
            <b-form-input
              v-model="infoPaciente.persona.apellidoMaterno"
              placeholder="Apellido materno:"
              disabled
            >
            </b-form-input>
          </b-col>
          <b-col>
            <label for="Nombre(s)"> Nombre(s): </label>
            <b-form-input
              v-model="infoPaciente.persona.nombre"
              placeholder="Nombre(s):"
              disabled
            >
            </b-form-input>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col>
            <label for="Fecha nacimiento"> Fecha nacimiento: </label>
            <b-form-input
              v-model="infoPaciente.persona.fechaNacimiento"
              placeholder="Fecha nacimiento:"
              disabled
            ></b-form-input>
          </b-col>
          <b-col>
            <label for="sobrenombre"> Sobrenombre: </label>
            <b-form-input
              v-model="infoPaciente.perfil.sobrenombre"
              placeholder="¿Como te gusta que te llamen? *"
              :state="
                infoPaciente.perfil.sobrenombre != '' &&
                infoPaciente.perfil.sobrenombre != null
              "
              required
            ></b-form-input>
            <b-form-invalid-feedback
              :state="
                infoPaciente.perfil.sobrenombre != '' &&
                infoPaciente.perfil.sobrenombre != null
              "
            >
              Se debe colocar un sobrenombre
            </b-form-invalid-feedback>
          </b-col>
          <b-col>
            <label for="sexo"> Sexo: </label>
            <b-form-input
              v-model="infoPaciente.persona.sexo"
              placeholder="Sexo:"
              disabled
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col>
            <label for="plan"> Plan: </label>
            <b-form-input
              v-model="infoPaciente.historia.nombrePlan"
              placeholder="Plan:"
              :disabled="infoPaciente.historia.idPlan != null"
              v-if="infoPaciente.historia.idPlan != null"
            ></b-form-input>

            <b-form-input
              v-model="nombrePlan"
              placeholder="Plan:"
              disabled
              v-else
            ></b-form-input>
          </b-col>
          <b-col>
            <b-form-group>
              <b-form-radio
                v-model="infoPaciente.historia.planTitularBeneficiario"
                :disabled="
                  idPlan == null && infoPaciente.historia.idPlan == null
                "
                value="1"
              >
                Titular
              </b-form-radio>
              <b-form-radio
                v-model="infoPaciente.historia.planTitularBeneficiario"
                :disabled="
                  idPlan == null && infoPaciente.historia.idPlan == null
                "
                value="2"
              >
                Beneficiario
              </b-form-radio>
            </b-form-group>
          </b-col>
          <b-col>
            <label>Motivo de la consulta: *</label>
            <b-form-input
              v-model="infoPaciente.historia.motivoConsulta"
              placeholder="Motivo"
              :state="infoPaciente.historia.motivoConsulta != null"
              required
            ></b-form-input>
            <b-form-invalid-feedback
              :state="infoPaciente.historia.motivoConsulta != null"
            >
              Se debe colocar el motivo
            </b-form-invalid-feedback>
          </b-col>
        </b-row>

        <b-row class="mt-4 mb-4">
          <b-col>
            <b-form-checkbox v-model="infoPaciente.historia.dolor" switch>
              ¿Presenta dolor?
            </b-form-checkbox>
          </b-col>
          <b-col>
            <label>Correo:</label>
            <b-form-input
              type="email"
              v-model="infoPaciente.persona.correo"
              placeholder="Correo:"
              disabled
            >
            </b-form-input>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <label>Teléfono celular:</label>
            <b-form-input
              v-model="infoPaciente.persona.telefono"
              placeholder="Teléfono:"
              disabled
            >
            </b-form-input>
          </b-col>
          <b-col>
            <label>Teléfono de casa:</label>
            <b-form-input
              v-model="infoPaciente.persona.casa"
              placeholder="Teléfono:"
              disabled
            >
            </b-form-input>
          </b-col>
          <b-col>
            <label>Teléfono del trabajo:</label>
            <b-form-input
              v-model="infoPaciente.persona.trabajo"
              placeholder="Teléfono:"
              disabled
            >
            </b-form-input>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col>
            <label>¿Cómo te enteraste de dentalia? *</label>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col sm="12" md="6" lg="4" xl="4" v-if="cargandoMedio">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </b-col>
          <b-col
            sm="12"
            md="4"
            lg="2"
            v-else
            xl="2"
            v-for="lista in listaEnterarse"
            :key="lista.label"
          >
            <b-form-group class="text-left" :label="lista.label">
              <b-form-radio-group
                v-model="infoPaciente.historia.idMedio"
                :options="lista.options"
                text-field="medio"
                value-field="idMedio"
                stacked
                :state="infoPaciente.historia.idMedio != null"
              >
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-form-invalid-feedback
            class="mb-4"
            :state="infoPaciente.historia.idMedio != null"
          >
            Se debe seleccionar una opción
          </b-form-invalid-feedback>
        </b-row>

        <h1 class="mt-4 mb-4 subtitulos">Antecedentes médicos</h1>
        <b-card-group deck>
          <b-card
            header-class="subtitulos"
            border-variant="primary"
            header="Cardiovascular"
          >
            <b-card-text>
              <b-row>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.cardioHipertension"
                    switch
                  >
                    Hipertensión
                  </b-form-checkbox>
                </b-col>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.cardioFiebreReumatica"
                    switch
                  >
                    Fiebre reumática
                  </b-form-checkbox>
                </b-col>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.cardioCirugia"
                    switch
                  >
                    Cirugía Cardíaca
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.cardioArritmias"
                    switch
                  >
                    Arritmias
                  </b-form-checkbox>
                </b-col>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.cardioOtroProblema"
                    switch
                    v-on:change="limpiar('cardioOtroProblema')"
                  >
                    Otro problema cardíaco
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-form-input
                v-model="infoPaciente.historia.cardioDescProblema"
                placeholder="¿Cuál?"
                :disabled="!infoPaciente.historia.cardioOtroProblema"
              >
              </b-form-input>
            </b-card-text>
          </b-card>

          <b-card
            header-class="subtitulos"
            border-variant="primary"
            header="Respiratorio"
          >
            <b-card-text>
              <b-row>
                <b-col
                  ><b-form-checkbox
                    v-model="infoPaciente.historia.respiratorioAsma"
                    switch
                  >
                    Asma
                  </b-form-checkbox>
                </b-col>
                <b-col
                  ><b-form-checkbox
                    v-model="infoPaciente.historia.respiratorioEnfisema"
                    switch
                  >
                    Enfisema
                  </b-form-checkbox>
                </b-col>
                <b-col
                  ><b-form-checkbox
                    v-model="infoPaciente.historia.respiratorioTuberculosis"
                    switch
                  >
                    Tuberculosis
                  </b-form-checkbox>
                </b-col>
                <b-col
                  ><b-form-checkbox
                    v-model="infoPaciente.historia.respiratorioOtroPadecimiento"
                    switch
                    v-on:change="limpiar('respiratorioOtroPadecimiento')"
                  >
                    Otro</b-form-checkbox
                  >
                </b-col>
              </b-row>
              <b-form-input
                v-model="infoPaciente.historia.descPadecimiento"
                placeholder="¿Cuál?"
                :disabled="!infoPaciente.historia.respiratorioOtroPadecimiento"
              >
              </b-form-input>
            </b-card-text>
          </b-card>
        </b-card-group>

        <b-card-group class="mt-4 mb-4" deck>
          <b-card
            header-class="subtitulos"
            border-variant="primary"
            header="Nervioso y sensorial"
          >
            <b-card-text>
              <b-row>
                <b-col>
                  <b-form-checkbox
                    v-model="
                      infoPaciente.historia.nerviosoTratamientoPsiquiatrico
                    "
                    switch
                    >Tratamiento psiquiátrico</b-form-checkbox
                  >
                </b-col>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.nerviosoCrisisConvulsivas"
                    switch
                    >Crisis convulsivas</b-form-checkbox
                  >
                </b-col>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.nerviosoOtroAntecedente"
                    switch
                    v-on:change="limpiar('nerviosoOtroAntecedente')"
                    >Otro</b-form-checkbox
                  >
                </b-col>
                <b-form-input
                  v-model="infoPaciente.historia.nerviosoDescAntecedente"
                  placeholder="¿Cuál?"
                  :disabled="!infoPaciente.historia.nerviosoOtroAntecedente"
                >
                </b-form-input>
              </b-row>
            </b-card-text>
          </b-card>

          <b-card
            header-class="subtitulos"
            border-variant="primary"
            header="Gineco obstétricos"
          >
            <b-card-text>
              <b-row>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.ginecoEmbarazada"
                    switch
                    :disabled="infoPaciente.persona.sexo != 2"
                    >¿Estás embarazada?</b-form-checkbox
                  >
                </b-col>
              </b-row>
            </b-card-text>
          </b-card>
        </b-card-group>

        <b-card-group deck>
          <b-card
            header-class="subtitulos"
            border-variant="primary"
            header="Hematología"
          >
            <b-card-text>
              <b-row>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.hematoTransfusiones"
                    switch
                    >Transfusiones</b-form-checkbox
                  >
                </b-col>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.hematoProblemaCoagulacion"
                    switch
                    >Problemas de coagulación</b-form-checkbox
                  >
                </b-col>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.hematoOtroPadecimiento"
                    switch
                    v-on:change="limpiar('hematoOtroPadecimiento')"
                    >Otro</b-form-checkbox
                  >
                </b-col>
                <b-form-input
                  v-model="infoPaciente.historia.hematoTratamientoPadecimiento"
                  placeholder="¿Cuál?"
                  :disabled="!infoPaciente.historia.hematoOtroPadecimiento"
                >
                </b-form-input>
              </b-row>
            </b-card-text>
          </b-card>

          <b-card
            header-class="subtitulos"
            border-variant="primary"
            header="Endocrinología"
          >
            <b-row>
              <b-col>
                <b-form-checkbox
                  v-model="infoPaciente.historia.endocrinoDiabetes"
                  switch
                  >Diabetes</b-form-checkbox
                >
              </b-col>
              <b-col>
                <b-form-checkbox
                  v-model="infoPaciente.historia.endocrinoTiroides"
                  switch
                  v-on:change="limpiar('endocrinoTiroides')"
                  >Enfermedad tiroidea</b-form-checkbox
                >
              </b-col>
              <b-form-input
                v-model="infoPaciente.historia.endocrinoDescTiroides"
                placeholder="¿Cuál?"
                :disabled="!infoPaciente.historia.endocrinoTiroides"
              >
              </b-form-input>
            </b-row>
          </b-card>
        </b-card-group>

        <b-card-group class="mt-4 mb-4" deck>
          <b-card
            header-class="subtitulos"
            border-variant="primary"
            header="Alergias"
          >
            <b-card-text>
              <b-row>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.alergiaPenicilina"
                    switch
                    >Penicilinas</b-form-checkbox
                  >
                </b-col>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.alergiaAntibiotico"
                    switch
                    >Antibióticos</b-form-checkbox
                  >
                </b-col>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.alergiaAntinflamatorio"
                    switch
                    >Antiinflamatorios</b-form-checkbox
                  >
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.alergiaAnalgesico"
                    switch
                    >Analgésicos</b-form-checkbox
                  >
                </b-col>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.alergiaSulfas"
                    switch
                    >Sulfas</b-form-checkbox
                  >
                </b-col>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.alergiaOtros"
                    switch
                    v-on:change="limpiar('alergiaOtros')"
                    >Otro</b-form-checkbox
                  >
                </b-col>
              </b-row>
              <b-form-input
                v-model="infoPaciente.historia.alergiaDescOtros"
                placeholder="¿Cuál?"
                :disabled="!infoPaciente.historia.alergiaOtros"
              >
              </b-form-input>
            </b-card-text>
          </b-card>

          <b-card
            header-class="subtitulos"
            border-variant="primary"
            header="Gastrointestinal"
          >
            <b-card-text>
              <b-row>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.gastroHepatitis"
                    switch
                    >Hepatitis</b-form-checkbox
                  >
                </b-col>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.gastroHepatica"
                    switch
                    >Enfermedad hepática</b-form-checkbox
                  >
                </b-col>
              </b-row>
            </b-card-text>
          </b-card>
        </b-card-group>

        <b-card-group class="mt-4 mb-4" deck>
          <b-card
            header-class="subtitulos"
            border-variant="primary"
            header="Urología"
          >
            <b-card-text>
              <b-row>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.urologiaEnfermedad"
                    switch
                    v-on:change="limpiar('urologiaEnfermedad')"
                    >Enfermedades renales</b-form-checkbox
                  >
                </b-col>
              </b-row>
              <b-form-input
                v-model="infoPaciente.historia.urologiaDescEnfermedad"
                placeholder="¿Cuál?"
                :disabled="!infoPaciente.historia.urologiaEnfermedad"
              >
              </b-form-input>
              <b-form-input
                v-model="infoPaciente.historia.urologiaTratamientoEnfermedad"
                placeholder="Tratamiento"
                :disabled="!infoPaciente.historia.urologiaEnfermedad"
              >
              </b-form-input>

              <b-row>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.urologiaSifilis"
                    switch
                    >Sífilis</b-form-checkbox
                  >
                </b-col>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.urologiaGonorrea"
                    switch
                    >Gonorrea</b-form-checkbox
                  >
                </b-col>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.urologiaHerpes"
                    switch
                    >Herpes Genital</b-form-checkbox
                  >
                </b-col>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.urologiaOtro"
                    switch
                    v-on:change="limpiar('urologiaOtro')"
                    >Otro</b-form-checkbox
                  >
                </b-col>
              </b-row>
              <b-form-input
                v-model="infoPaciente.historia.urologiaOtroDesc"
                placeholder="Especificar cual enfermedad"
                :disabled="!infoPaciente.historia.urologiaOtro"
              >
              </b-form-input>

              <b-row>
                <b-col>
                  <b-form-checkbox
                    v-model="infoPaciente.historia.urologiaVih"
                    switch
                    v-on:change="limpiar('urologiaVih')"
                    >VIH Positivo</b-form-checkbox
                  >
                </b-col>
              </b-row>
              <b-form-input
                v-model="infoPaciente.historia.urologiaDescVih"
                placeholder="Tratamiento y fecha del mismo"
                :disabled="!infoPaciente.historia.urologiaVih"
              >
              </b-form-input>
            </b-card-text>
          </b-card>
        </b-card-group>

        <h1 class="subtitulos">Datos de atención médica</h1>
        <b-form-checkbox
          class="mt-4 mb-4"
          v-model="infoPaciente.historia.pastilla"
          switch
          v-on:change="limpiar('pastilla')"
          >¿Está usted tomando algún tipo de medicina o
          pastilla?</b-form-checkbox
        >
        <b-row>
          <b-col>
            <b-form-input
              v-model="infoPaciente.historia.pastillaCuales"
              placeholder="¿Cuáles?"
              :disabled="!infoPaciente.historia.pastilla"
            >
            </b-form-input>
          </b-col>
          <b-col>
            <b-form-input
              v-model="infoPaciente.historia.pastillaDosis"
              placeholder="Dosis"
              :disabled="!infoPaciente.historia.pastilla"
            >
            </b-form-input>
          </b-col>
          <b-col>
            <b-form-input
              v-model="infoPaciente.historia.frecuencia"
              placeholder="Frecuencia"
              :disabled="!infoPaciente.historia.pastilla"
            >
            </b-form-input>
          </b-col>
        </b-row>

        <p class="mt-4 txtLeft boldBlue">
          De conformidad con la norma oficial mexicana número NOM-004-SSA3-2012,
          los expedientes clínicos son propiedad del prestador de servicios que
          los genera, en ese tenor, no se podrán entregar constancias o
          documentos que forman parte del mismo, ni tampoco copia alguna,
          incluyendo estudios, radiografías, modelos, etc.
          <br />
          <br />El paciente como propietario de la información que proporciona
          para su atención odontológica y al ser beneficiario de los servicios
          médicos, tiene derecho de titularidad sobre la información para la
          protección de su salud, así como para la protección de la
          confidencialidad de sus datos en términos de nuestro aviso de
          privacidad.
          <br />
          <br />Manifiesto que todos los datos en la presente solicitud fueron
          declarados por mí, son verídicos y correctos.
        </p>


        <b-button type="submit" variant="outline-primary" v-if="!enviando">
          Guardar
        </b-button>
        <b-button variant="primary" v-show="enviando" disabled>
          <b-spinner small></b-spinner>
          Cargando...
        </b-button>
      </div>
    </b-form>
  </div>
</template>
<script>
import VueNotifications from "vue-notifications";
export default {
  name: "historiaEmergencia",
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      existeFirma: false,
      edicionLinkUsuario: false,
      urlBase: null,
      idPaciente: null,
      nombrePlan: "",
      idPlan: null,
      listaEnterarse: [],
      infoPaciente: {
        persona: {
          idPersona: null,
          apellidoMaterno: "",
          apellidoPaterno: "",
          nombre: "",
          fechaNacimiento: "",
          sexo: "",
          correo: "",
          telefono: "",
          casa: "",
          trabajo: "",
        },
        perfil: {
          idPersonaPerfil: null,
          sobrenombre: "",
        },
        historia: {
          idHistoriaClinica: null,
          idPaciente: null,
          idClinica: null,
          idPlan: null,
          nombrePlan: "",
          planTitularBeneficiario: null,
          motivoConsulta: "",
          dolor: false,
          idMedio: null,
          cardioHipertension: false,
          cardioFiebreReumatica: false,
          cardioCirugia: false,
          cardioArritmias: false,
          cardioOtroProblema: false,
          cardioDescProblema: "",
          respiratorioAsma: false,
          respiratorioEnfisema: false,
          respiratorioTuberculosis: false,
          respiratorioOtroPadecimiento: false,
          descPadecimiento: "",
          nerviosoTratamientoPsiquiatrico: false,
          nerviosoCrisisConvulsivas: false,
          nerviosoOtroAntecedente: false,
          nerviosoDescAntecedente: "",
          ginecoEmbarazada: false,
          hematoTransfusiones: false,
          hematoProblemaCoagulacion: false,
          hematoOtroPadecimiento: false,
          hematoTratamientoPadecimiento: "",
          endocrinoDiabetes: false,
          endocrinoTiroides: false,
          endocrinoDescTiroides: "",
          alergiaPenicilina: false,
          alergiaAntibiotico: false,
          alergiaAntinflamatorio: false,
          alergiaAnalgesico: false,
          alergiaSulfas: false,
          alergiaOtros: false,
          alergiaDescOtros: "",
          gastroHepatitis: false,
          gastroHepatica: false,
          urologiaEnfermedad: false,
          urologiaDescEnfermedad: "",
          urologiaTratamientoEnfermedad: "",
          urologiaSifilis: false,
          urologiaGonorrea: false,
          urologiaHerpes: false,
          urologiaOtro: false,
          urologiaOtroDesc: "",
          urologiaVih: false,
          urologiaDescVih: "",
          pastilla: false,
          pastillaCuales: "",
          pastillaDosis: "",
          frecuencia: "",
          fechaModificacion: "",
        },
      },
      enviando: false,
      cargandoMedio: true,
      verFirma: null,
    };
  },
  props: {
    idPacienteProp: Number,
    idClinicaProp: Number,
  },
  async created() {
    this.debug = this.$localStorageService.getDebug();

    this.idClinica=this.$localStorageService.getIdClinica()
    this.idPaciente = this.$route.params.id;
    this.urlBase = this.$api;

    if (this.idPacienteProp !== undefined && this.idClinicaProp !== undefined) {
      this.idPaciente = this.idPacienteProp;

      this.edicionLinkUsuario = true;
      this.urlBase = this.$baseURL + "/";
    }

    this.verFirma = await this.vadicionActivarEceClinica();
    //traemos historial, sexo y enterarse por grupo
    this.traerPlanes();
    this.traerMedio();

    this.traerDatosPaciente();
    if (this.infoPaciente.historia.idHistorialClinica == null) {
      this.infoPaciente.historia.fechaModificacion = this.$global.traerFechaLocal(
          this.$global.traerFecha()
      );
    }
  },
  methods: {
    async validacionActivaHerramientasHdx(){
      return await this.$http
          .get(this.urlBase +"rutaExpediente/validacionActivaHdx")
    },
    async vadicionActivarEceClinica() {
      const parametros = {idClinica: this.idClinica}
      return await this.$http.post(
          this.$api + "catalogos/obtenerClinicasActivasECE", parametros
      );
    },
    verificarExisteFirma(value) {
      this.existeFirma = value;
    },
    traerPlanes() {
      this.cargandoPlanes = true;
      const datos = {
        idPaciente: this.idPaciente
      }
      let urlPlanes =
        this.urlBase +
        "paciente/perfiles/obtenerPlanesPaciente";

      this.$http
        .post(urlPlanes, datos)
        .then((response) => {
          if (response.data.data) {
            let idPlan = null;
            let nombrePlan = "";
            response.data.data.forEach((plan) => {
              idPlan = plan.id;
              nombrePlan = plan.nombre;
            });
            this.idPlan = idPlan;
            this.nombrePlan = nombrePlan;
            this.cargandoPlanes = false;
          }
        })
        .catch((err) => {
          this.errorMensaje(err);
          this.cargandoPlanes = false;
        });
    },
    traerMedio() {
      let urlMedio = this.urlBase + "paciente/catalogo/listaMedio";
      this.$http
        .get(urlMedio)
        .then((response) => {
          if (response.data.data) {
            this.listaEnterarse = response.data.data;
          }
        })
        .catch((err) => {
          this.errorMensaje(err);
        })
        .finally(() => {
          this.cargandoMedio = false;
        });
    },
    traerDatosPaciente() {
      let urlPaciente =
        this.urlBase + "paciente/historial?idPaciente=" + this.idPaciente;

      this.$http
        .get(urlPaciente)
        .then((response) => {
          if (response.data.data) {
            this.infoPaciente = response.data.data;

            //persona
            this.infoPaciente.persona.fechaNacimiento = this.$global.traerFechaLocal(
              response.data.data.persona.fechaNacimiento
            );
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    limpiar(variable) {
      switch (variable) {
        case "cardioOtroProblema":
          this.infoPaciente.historia.cardioDescProblema = "";
          break;
        case "respiratorioOtroPadecimiento":
          this.infoPaciente.historia.descPadecimiento = "";
          break;
        case "nerviosoOtroAntecedente":
          this.infoPaciente.historia.nerviosoDescAntecedente = "";
          break;
        case "hematoOtroPadecimiento":
          this.infoPaciente.historia.hematoTratamientoPadecimiento = "";
          break;
        case "endocrinoTiroides":
          this.infoPaciente.historia.endocrinoDescTiroides = "";
          break;
        case "alergiaOtros":
          this.infoPaciente.historia.alergiaDescOtros = "";
          break;
        case "urologiaEnfermedad":
          this.infoPaciente.historia.urologiaDescEnfermedad = "";
          this.infoPaciente.historia.urologiaTratamientoEnfermedad = "";
          break;
        case "urologiaOtro":
          this.infoPaciente.historia.urologiaOtroDesc = "";
          break;
        case "urologiaVih":
          this.infoPaciente.historia.urologiaDescVih = "";
          break;
        case "pastilla":
          this.infoPaciente.historia.pastillaCuales = "";
          this.infoPaciente.historia.pastillaDosis = "";
          this.infoPaciente.historia.frecuencia = "";
          break;
      }
    },

    enviarFormulario() {
      if (!this.validarDatos()) {
        this.guardarEditarhistoria();
      }
    },
    guardarEditarhistoria() {
      this.$swal({
        icon: "warning",
        text: "¿Los datos son correctos?",
        confirmButtonColor: "#0e6ba9",
        cancelButtonColor: "#8e8e8e",
        confirmButtonText: "Enviar",
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.enviando = true;
          this.enviarDatos();
        }
      });
    },
    enviarDatos() {
      let urlEditar = this.urlBase + "paciente/historial";
      this.$http
        .post(urlEditar, this.acomodarDatos())
        .then((response) => {
          if (response.status === 200) {
            this.enviando = false;
            this.$swal({
              icon: "success",
              text: "Se guardó su historial clínico",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          }
        })
        .catch((err) => {
          this.enviando = false;
          this.errorEnvio(err);
        });
    },
    validarDatos() {
      let error = false;
      if (this.infoPaciente.historia.idMedio == null) {
        this.$swal({
          icon: "error",
          text:
              "Debe seleccionar una opción de '¿Cómo te enteraste de dentalia?'",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });

        error = true;
      }
      return error;
    },
    acomodarDatos() {
      let persona = {
        "casa": this.infoPaciente.persona.casa,
        "trabajo": this.infoPaciente.persona.trabajo,
        "telefono": this.infoPaciente.persona.telefono,
        "correo": this.infoPaciente.persona.correo,
        "sexo": this.infoPaciente.persona.sexo,
        idPersona: this.infoPaciente.persona.idPersona,
      };


      let perfil = {
        idPersonaPerfil: this.infoPaciente.perfil.idPersonaPerfil,
        sobrenombre: this.infoPaciente.perfil.sobrenombre.trim(),
        idPersona: this.infoPaciente.persona.idPersona,
      };



      let historial = this.infoPaciente.historia;
      historial.idPaciente = this.idPaciente;


      if (this.edicionLinkUsuario) {
        historial.idClinica = this.infoPaciente.historia.idClinica;
      } else {
        historial.idClinica =
            this.infoPaciente.historia.idClinica != null
                ? this.infoPaciente.historia.idClinica
                : this.$localStorageService.getIdClinica();
      }

      historial.idPlan =
        this.infoPaciente.historia.idPlan != null
          ? this.infoPaciente.historia.idPlan
          : this.idPlan;
      delete historial.fechaModificacion;
      delete historial.nombrePlan;

      if (this.edicionLinkUsuario) {
        historial.usuarioLogeado = 1;
      } else {
        historial.usuarioLogeado = this.$localStorageService.getIdUsuario();
      }

      return {
        persona: persona,
        perfil: perfil,
        historia: historial,
      };
    },
  },
  notifications: {
    errorMensaje: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al traer la información",
    },
    errorEnvio: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al enviar la información",
    },
  },
};
</script>
